// App.js
import React from 'react';
import './App.css';
import StudentForm from './StudentForm';

function App() {
  return (
    <div className="container">
      {/* Left column (logo) */}
      <div className="left-column"></div>
      
      {/* Right column (form) */}
      <div className="right-column">
        <StudentForm />
      </div>
    </div>
  );
}

export default App;
